import { get, post } from './http'

//登录
export const userLoginApi = data => post('user/login', data); //登录
export const logoutApi = data => post('user/logout', data)    //登出
export const forgetApi = data => post('user/resetPwd', data)    //重设密码
export const getcodeApi = data => get('common/getCaptcha', data)  //获取验证码

//注册
export const getregister = data => post("user/regist", data)      //注册

//首页
export const gethomeApi = data => get('home', data);

//banner
export const getbannerApi=data=>get('common/banner/list',data)  //banner图

// 理论训练
export const geTtheoryTrainApi=data=>get("theoryExercise/list",data)
export const getexamApi=data=>get("theoryExercise/detail",data)  //开始答题
export const getsubmitExamApi=data=>post("theoryExercise/commitExerciseAnswer",data)  //交卷

//虚拟仿真
export const getsimulationlistApi=data=>get('product/productList',data)  
export const getsimulationsoftlistApi=data=>get("product/softType",data)  //分类
export const getsimulationDetailApi=data=>get("product/productDetail",data) //详情
export const getcommitApplyApi=data=>post('product/commitApply',data)  //申请试用

//阿里云视频
export const getisvideoApi=data=>post('aliyunVod/getPlayAuth',data)   //阿里云获取凭证
export const getaliyunVodApi=data=>post('aliyunVod/getPlayInfo',data)    //视频地址

//课程中心
export const getcourseListApi = data => get('course/list', data);    //教学课堂
export const getcourseDetailApi = data => get('course/detail', data);   //教学课堂目录
export const getcontinueApi = data => get('course/continue', data);     //教学课堂继续学习
export const getcatalogApi = data => get('course/task/detail', data);   //教学课堂目录详情
export const getcatDetail = data => get('course/task/paperDetail', data)   //教学课堂目录查看测试，理论考试详情
export const getprexamApi = data => get('course/task/operationQuestion', data)   //实操考试详情
export const getcoursecommonApi = data => get('common/majorList', data)   //教学课堂分类
export const joincourseApi = data => post('course/join', data)            //是否加入此课程
export const getanswerApi = data => get('course/ask/list', data)    //问答
export const getanswerDetailApi = data => get('course/ask/detail', data)    //问答详情
export const getreplyApi = data => post('course/reply/commit', data)     //问答回复
export const getaskApi = data => post('course/ask/commit', data)     //问答提问
export const getcultivateApi = data => get('trainingProgram/list', data)   //人才培养
export const getcultivateDetailApi = data => get('trainingProgram/detail', data)  //人才培养详情
export const getcommitPaperApi = data => post('course/task/commitPaper', data)      //交卷
export const getupdateStatusApi = data => post('course/task/updateStatus', data)    //判断是否完成交卷
export const getscheduledAnswerApi = data => post('course/task/scheduledAnswer', data)    //及时提交
export const getcollectApi = data => post('course/collect', data)   //课程收藏
export const getSeekTimeApi=data=>post('course/task/updateStudyTime',data)   //视频续播

//个人中心
export const getmyInfo = data => get('personalCenter/myInfo', data)    //基本信息
export const getupdateInfo = data => post('personalCenter/updateInfo', data)    //修改个人信息
export const getupload = data => post('common/upload', data)   //上传图片
export const getupdatepwd = data => post('personalCenter/updatePwd', data)    //修改密码
export const getcourseApi = data => get('personalCenter/myCourse', data)   //我的课程
export const getlectureApi = data => get('personalCenter/myLecture', data)    //我的直播
export const gettrainApi = data => get('personalCenter/myTraining', data)   //我的培训
export const getinvlintrainApi=data=>get("personalCenter/onePlusXTraining",data)   //监考的培训
export const getinvigilatorConfirmApi=data=>post('personalCenter/invigilatorConfirm',data)  //同意监考考试/培训
export const getonePlusXExamApi=data=>get('personalCenter/onePlusXExam',data)    //我参加的考试与监考的考试
export const getscoreApi = data => get('personalCenter/myCert', data)   //成绩和证书
export const getmyanswerApi = data => get('personalCenter/myAskAndAnswer', data)   //我的问答
export const getdeleteMyAsk = data => post('personalCenter/deleteMyAsk', data)  //删除我的提答
export const getdeleteMyReply = data => post('personalCenter/deleteMyReply', data)   //删除我的问答
export const getmessageApi = data => get('personalCenter/messageDetail', data)   //查看消息
export const getmessagelistApi = data => get('personalCenter/messageList', data)   //查看消息列表
export const getdelmessageApi = data => post('personalCenter/deleteMessage', data)  //删除信息
export const getclassListApi = data => get('personalCenter/classList', data)   //获取班级列表
export const getmyCourseListApi = data => get('personalCenter/common/myCourseList', data)   //课程名称
export const getaddclassApi = data => post('personalCenter/addClass', data)   //新增班级
export const getupdateClassApi = data => post('personalCenter/updateClass', data)  //修改班级名
export const getdelclassApi = data => post('personalCenter/deleteClass', data)   //删除班级
export const getstudentApi = data => get('personalCenter/studentList', data)   //学生列表
export const getstudytscoreApi = data => get('personalCenter/studyList', data)   //学情查看
export const getaddstudentApi = data => post('personalCenter/registStudent', data)   //新增学生
export const getaddstudentclassApi = data => post('personalCenter/addStudent', data)  //新增学生到班级
export const getimportUserToClassApi = data => post('personalCenter/importUserToClass', data)  //导入学生信息
export const getremovestudentApi = data => post('personalCenter/removeStudent', data)  //移除学生
export const getloadTemplateApi = data => get('personalCenter/downloadTemplate', data)  //下载模板
export const getupdatastudentApi = data => post('personalCenter/updateStudent', data)  //修改学生信息
export const getmyclassApi = data => get('personalCenter/myClass', data)  //我的班级
export const getclassmateApi = data => get('personalCenter/classmate', data)   //我的同学
export const getcheckPhoneApi = data => get('user/checkPhone', data)   //检测手机
export const expertApplyApi=data=>post('personalCenter/expertApply',data)  //专家申请
export const checkExpertAppliedApi=data=>post('personalCenter/checkExpertApplied',data)    //检查专家申请
export const getexamlistApi=data=>get("personalCenter/exerciseRecordList",data)  //我的训练
export const getrandomApi=data=>get("personalCenter/randomExerciseRecordDetail",data)  //随机试卷
export const updatePhotoApi=data=>post('personalCenter/updatePhoto',data)  //修改证书头像

export const bingphomeApi=data=>post('personalCenter/bindTelephone',data)   //绑定电话号码
export const checkPhoneApi=data=>get("user/checkPhone",data)   //检查手机号码
export const exportStudyListApi=data=>post('personalCenter/exportStudyList',data)   // 学情查看导出
export const getinstituteCenterApi=data=>get('instituteCenter/info',data)   //基本信息
export const getcommitMembershipApplyApi=data=>post('personalCenter/commitMembershipApply',data)   //会员申请

